import React from "react";
import "./Header.css";

const Header = (props) => {
    return (
        <header className="app-header">
            {props.children}
            <h3 className="centered">Customer Manager</h3>
        </header>
    );
};

export default Header;